import React, { memo } from "react";

import PropTypes from "prop-types";

import { CURRENCY_SYMBOLS_MAP, eurCountries } from "../Utils/constants";

const currencyPrefixSymbol = (country, currency, type = "element") => {
  if (currency) {
    const currencyIcon = CURRENCY_SYMBOLS_MAP[currency.toUpperCase()];

    switch (currency.toUpperCase()) {
      case "INR":
        return type === "string" ? (
          "inr"
        ) : (
          <span className="rupee-icon">{currencyIcon}</span>
        );
      case "EUR":
        return type === "string" ? (
          "eur"
        ) : (
          <span className="rupee-icon">{currencyIcon}</span>
        );
      default:
        return type === "string" ? (
          "usd"
        ) : (
          <span className="rupee-icon">{currencyIcon}</span>
        );
    }
  }

  if (country && ["IN", "INDIA"].includes(country.toUpperCase())) {
    return type === "string" ? (
      "inr"
    ) : (
      <span className="rupee-icon">{CURRENCY_SYMBOLS_MAP.INR}</span>
    );
  }

  if (country && eurCountries.includes(country.toUpperCase())) {
    return type === "string" ? (
      "eur"
    ) : (
      <span className="rupee-icon">{CURRENCY_SYMBOLS_MAP.EUR}</span>
    );
  }

  return type === "string" ? (
    "usd"
  ) : (
    <span className="rupee-icon">{CURRENCY_SYMBOLS_MAP.USD}</span>
  );
};

const CurrencySymbol = ({ country, currency, type = "element" }) => {
  const getCurrencySymbol = () => {
    const countryCode = country ? country.toUpperCase() : "INR";
    return currencyPrefixSymbol(countryCode, currency, type);
  };

  return <>{getCurrencySymbol()}</>;
};

CurrencySymbol.propTypes = {
  country: PropTypes.string,
  currency: PropTypes.string,
  type: PropTypes.string,
};

export default memo(CurrencySymbol);
